import axiosInstance from "../utils/axios"



export const createTopic =async (payload)=>{
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 
     return await axiosInstance.post(`/api/create-topic`, payload, {headers})

    } catch (error) {
       throw error
    }
}

export const getTopic =async (payload)=>{
  console.log(payload)
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 

    const params={
        name: payload?.name
    }
    return await axiosInstance.get(`/api/get-all-topics`, {headers, params:{...payload}})

    } catch (error) {
       throw error
    }
}

export const deleteTopic =async (topicId)=>{
  console.log(topicId)
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 
     return await axiosInstance.delete(`/api/delete-topic/${topicId}`, {headers})

    } catch (error) {
       throw error
    }
}
export const getTopicById =async (payload)=>{
  console.log(payload)
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 

    const params={
        name: payload?.name
    }
    return await axiosInstance.get(`/api/update-topic/:id`, {headers, params:{...payload}})

    } catch (error) {
       throw error
    }
}
export const updateTopic =async (payload,topicId)=>{
  // console.log(payload)
  console.log(topicId)
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 
    return await axiosInstance.put(`/api/update-topic/${topicId}`,payload,{headers})

    } catch (error) {
       throw error
    }
}